import type {Entity,Tile} from './types';
/** SW-anchored tiles use +x east and +y south; renderer maps y to world +z. */
export function centerOf(entity:Pick<Entity,'tile'|'size'>,tile:Tile=entity.tile):Tile{
 return {x:tile.x+entity.size/2,y:tile.y-entity.size/2};
}
/** Three.js yaw: 0 faces +z (south), +pi/2 faces +x (east). */
export function facingToward(from:Tile,to:Tile,unchanged=0):number{
 const dx=to.x-from.x,dy=to.y-from.y;
 return dx===0&&dy===0?unchanged:Math.atan2(dx,dy);
}
